// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionIntro_root__27oc_","title":"SectionIntro_title__2vB4T","text":"SectionIntro_text__3aDRN","icon":"SectionIntro_icon__5zwzs"};